// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PriceInstantBook_wrapper__6qnJ0"};